import { createContext } from 'react';
import { VirgoContentContextType } from 'utils/types';

const VirgoContentContext = createContext<VirgoContentContextType>({
  banners: { status: 'loading', data: [] },
  chips: { status: 'loading', data: [] },
  circles: { status: 'loading', data: [] },
  topMenu: [],
  fetchFYPContent: () => {},
});

export default VirgoContentContext;
